// extracted by mini-css-extract-plugin
module.exports = {"container":"Kpis_container__3ZOaq","item":"Kpis_item__mZiJa"};